import React from "react";

const SaveStatusContext = React.createContext({ saveStatus: "", dispatchSaveStatus: () => {} });
export default SaveStatusContext;
export const useSaveStatusContext = () => React.useContext(SaveStatusContext);
